import React from 'react';

/**
 * Locked 48px pane chrome for split-screen verification modals.
 *
 * HR (and the worker on the compose counterpart) treats the two columns as one
 * compare-and-decide desk: evidence on the left, claim on the right. The pane
 * titles and their bottom divider are the shared horizon line. If one bar grows
 * (`min-h-12` hugging a button) the preview and the form start on different Y
 * positions and every glance has to re-register "which row am I on."
 *
 * Both panes MUST render this. Do not hand-roll a substitute, and never use
 * `min-h-12` — that is a floor, so a compact trailing control plus `py-3`
 * grows the bar and staggers the columns. Trailing actions must be compact:
 * `btn-sm` (36px), `InfoBadge`, or `StatusBadge`. A default `.btn` (44px)
 * will overflow the 48px lock.
 *
 * Desktop only in the host modal — hide this when `MobileVerificationTabs`
 * already labels the surface.
 */
const VerificationPanelHeader = ({ title, icon: Icon, trailing }) => (
  <div className="px-4 py-3 border-b border-gray-200 bg-white flex items-center justify-between gap-2 flex-shrink-0 h-12">
    <h4 className="font-semibold text-gray-900 truncate min-w-0 flex items-center">
      {Icon ? <Icon className="w-4 h-4 mr-2 flex-shrink-0" aria-hidden="true" /> : null}
      {title}
    </h4>
    {trailing ? (
      <div className="flex items-center gap-2 flex-shrink-0">{trailing}</div>
    ) : null}
  </div>
);

export default VerificationPanelHeader;
